import axiosClient from './axios';

export async function questionPet(petdata) {
  try {
    axiosClient.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token').replace(/['"]+/g, '')}`
    const response = await axiosClient.post('/pregunta', petdata);
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function answerPet(answerData) {
  try {
    axiosClient.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token').replace(/['"]+/g, '')}`
    const response = await axiosClient.post('/respuesta', answerData);
    return response;
  } catch (error) {
    console.log(error);
  }
}

export async function getQuestionAnswerPet(questionData) {
  try {
    axiosClient.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token').replace(/['"]+/g, '')}`
    const response = await axiosClient.post('/ObtenerPreguntaRespuesta', questionData);
    return response;
  } catch (error) {
    console.log(error);
  }
}
